<template>
  <div>
    <el-dialog
      title="基础配置权限"
      custom-class="perm-modal"
      :visible.sync="formVisible"
      width="900px"
      top="20px"
      :close-on-click-modal="false"
    >
      <div class="perm-modal-table">
        <div class="table-header">
          <div style="width: 100%">
            平台类型
            <el-checkbox
              style="margin-left: 10px"
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选
            </el-checkbox>
          </div>
        </div>
        <div class="table-content flex">
          <el-checkbox-group
            v-model="platTypePerms"
            @change="changePlatTypePerm"
          >
            <el-checkbox
              v-for="item in platTypeList"
              :label="item.typeValue"
              :key="item.typeValue"
              :disabled="item.typeValue != 0 && platTypePerms.includes(0)"
              >{{ item.labelName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <!-- <div class="table-header">
          <div style="width: 100%">渠道权限</div>
        </div>
        <div class="table-content flex">
          <el-checkbox
            style="margin-right: 30px"
            :indeterminate="isChannelPermIndeterminate"
            v-model="channelPermCheckAll"
            @change="handleChannelPermCheckAllChange"
            >全选</el-checkbox
          >
          <el-checkbox-group v-model="channelPerm" @change="changeChannelPerm">
            <el-checkbox
              v-for="item in channelList"
              :label="item.typeValue"
              :key="item.typeValue"
              >{{ item.labelName }}</el-checkbox
            >
          </el-checkbox-group>
        </div> -->
        <div class="table-header">
          <div style="width: 100%">
            工作室/小组
            <el-checkbox
              style="margin-left: 10px"
              v-model="groupAllCheck"
              @change="handleGroupAllSelect"
              >全选
            </el-checkbox>
          </div>
        </div>
        <div class="table-content">
          <div class="tablet-border">
            <div class="left-border">
              <div
                class="leftItem"
                v-for="(item, index) in groupList"
                :key="item.labelName"
                @click.stop="handleCheckedChild(index)"
              >
                <el-checkbox
                  v-model="item.isPerm"
                  :indeterminate="handleIndeterminateFlag(item)"
                  :disabled="item.typeValue != 0 && groupList[0].isPerm"
                  @change="(value) => handleCheckboxChange(value, index)"
                  >{{ item.labelName }}
                </el-checkbox>
                <i
                  v-if="item.typeValue != 0"
                  class="el-icon-arrow-right"
                  :style="{
                    color: index === currentCheckIndex ? '#2a56e3' : '#C0C4CC',
                  }"
                  @click="handleCheckedChild(index)"
                ></i>
              </div>
            </div>
            <div class="right-border">
              <div
                :class="{
                  rightItem:
                    index !== groupList[currentCheckIndex]?.children.length - 1,
                  rightItemLast:
                    index === groupList[currentCheckIndex]?.children.length - 1,
                }"
                v-for="(item, index) in groupList[currentCheckIndex]?.children"
                :key="`${item.labelName}_${index}`"
              >
                <el-checkbox
                  v-model="item.isPerm"
                  :disabled="
                    groupList[0].isPerm ||
                    (item.typeValue != item.parentId &&
                      groupList[currentCheckIndex]?.children[0].isPerm)
                  "
                  @change="(value) => handleChildCheckboxChange(value, item)"
                  >{{ item.labelName }}
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="table-header">
          <div style="width: 100%">
            地区权限
            <el-tooltip
              style="margin-left: 0px"
              class="item"
              effect="dark"
              placement="top-start"
            >
              <div slot="content">不作用于产品默认授权</div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="table-content">
          <el-radio-group v-model="geoPerm">
            <el-radio
              v-for="item in geoList"
              :key="item.typeValue"
              :label="item.typeValue"
              >{{ item.labelName }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm" v-loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserRefPerms,
  getRoleRefPerms,
  saveUserRefPerms,
  saveRoleRefPerms,
} from "@/api/account-management.js";
export default {
  data() {
    return {
      formVisible: false,
      platTypeList: [],
      platTypePerms: [],
      channelPerm: [],
      geoList: [],
      geoPerm: "",
      checkAll: false,
      isIndeterminate: true,
      loading: false,
      // 工作室/小组
      groupList: [],
      currentCheckIndex: 1,
      // 工作室/小组全选
      groupAllCheck: false,
    };
  },
  props: {
    refType: Number,
  },
  computed: {
    handleIndeterminateFlag() {
      return (value) => {
        if (value.children?.length > 0) {
          let num = 0;

          value.children.forEach((e) => {
            if (e.isPerm) num++;
          });

          if (num > 0 && num < value.children.length) {
            return true;
          }
        }

        return false;
      };
    },
  },
  methods: {
    showModal(data) {
      const api = this.refType == 1 ? getRoleRefPerms : getUserRefPerms;
      const key = this.refType == 1 ? "roleId" : "userId";
      this.formVisible = true;
      (this.groupAllCheck = false),
        api({
          [key]: data.id,
        }).then((res) => {
          const data = JSON.parse(JSON.stringify(res.data));
          this.platTypePerms = [];
          this.platTypeList = data[0];
          this.platTypeList.map((item) => {
            if (item.isPerm) {
              this.platTypePerms.push(item.typeValue);
            }
          });
          this.changePlatTypePerm();

          // this.allChannelData = data[1][0];
          // this.channelPerm = [];
          // this.channelList = data[1].slice(1);
          // this.channelList.map((item) => {
          //   if (item.isPerm) {
          //     this.channelPerm.push(item.typeValue);
          //   }
          // });
          // this.changeChannelPerm();

          // 工作室小组处理
          this.groupList = data[2];
          this.geoList = data[1];
          this.geoPerm = this.geoList.find((item) => item.isPerm)?.typeValue;
        });
    },
    handleCheckedChild(index) {
      this.currentCheckIndex = index;
    },
    handleGroupAllSelect(value) {
      if (value) {
        // 全选
        this.groupList = this.groupList.map((i) => {
          return {
            ...i,
            isPerm: i.typeValue != i.parentId ? true : false,
            children: i.children?.map((o) => {
              return {
                ...o,
                isPerm: o.typeValue != o.parentId ? true : false,
              };
            }),
          };
        });
      } else {
        // 非全选
        this.groupList = this.groupList.map((i) => {
          return {
            ...i,
            isPerm: false,
            children: i.children?.map((o) => {
              return {
                ...o,
                isPerm: false,
              };
            }),
          };
        });
      }
    },
    // 左边菜单栏选择框
    handleCheckboxChange(value, index) {
      this.currentCheckIndex = index;
      // 点击所有
      if (index == 0) {
        if (value) {
          this.groupAllCheck = true;
          // 全选
          this.groupList = this.groupList.map((i) => {
            return {
              ...i,
              isPerm: true,
              children: i.children?.map((o) => {
                return {
                  ...o,
                  isPerm: true,
                };
              }),
            };
          });
        }
      } else {
        if (value) {
          // 选中状态
          this.groupList = this.groupList.map((o, oIndex) => {
            if (oIndex === index) {
              return {
                ...o,
                children: o.children?.map((c) => {
                  return {
                    ...c,
                    isPerm: c.typeValue != c.parentId ? true : false,
                  };
                }),
              };
            }

            return o;
          });
        } else {
          // 未选中状态
          this.groupList = this.groupList.map((o, oIndex) => {
            if (oIndex === index) {
              return {
                ...o,
                children: o.children?.map((c) => {
                  return {
                    ...c,
                    isPerm: false,
                  };
                }),
              };
            }

            return o;
          });
        }
      }
    },
    // 右边菜单栏选择框
    handleChildCheckboxChange(value, childItem) {
      if (value) {
        // 选中状态
        this.groupList = this.groupList.map((o) => {
          if (o.typeValue === childItem.parentId) {
            return {
              ...o,
              isPerm: true,
            };
          }

          return o;
        });
        // 选中的 所有
        if (childItem.typeValue == childItem.parentId) {
          const findIndex = this.groupList.findIndex(
            (item) => item.typeValue === childItem.parentId
          );
          if (findIndex > -1) {
            this.groupList[findIndex].children?.map((child) => {
              this.$set(child, "isPerm", true);
            });
          }
        }
      } else {
        // 未选中状态且右边栏为空时左边栏选中取消
        this.groupList = this.groupList.map((o) => {
          if (o.typeValue === childItem.parentId) {
            if (o.children.findIndex((i) => i.isPerm) === -1) {
              return {
                ...o,
                isPerm: false,
              };
            }
            return o;
          }
          return o;
        });
      }
    },
    handleCheckAllChange(value) {
      const list = this.platTypeList.filter((item) => item.typeValue != 0);
      this.platTypePerms = value ? list.map((item) => item.typeValue) : [];
      this.isIndeterminate = false;
    },
    // handleChannelPermCheckAllChange(value) {
    // this.channelPerm = value ? this.channelList.map((item) => item.typeValue) : [];
    // this.isChannelPermIndeterminate = false;
    // },
    changePlatTypePerm() {
      if (this.platTypePerms.includes(0)) {
        this.platTypePerms = this.platTypeList.map((item) => item.typeValue);
        this.isIndeterminate = false;
      }
      let checkedCount = this.platTypePerms.filter((item) => item != 0)?.length;
      this.checkAll = checkedCount === this.platTypeList.length - 1;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.platTypeList.length - 1;
    },
    // changeChannelPerm() {
    // let checkedCount = this.channelPerm.length;
    // this.channelPermCheckAll = checkedCount === this.channelList.length;
    // this.isChannelPermIndeterminate = checkedCount > 0 && checkedCount < this.channelList.length;
    // },
    handleCancel() {
      this.formVisible = false;
    },
    handleConfirm() {
      // if (this.platTypePerms.length == 0) {
      //   this.$message.warning("请至少设置一个平台类型权限");
      //   return;
      // }
      // if (this.channelPerm.length == 0) {
      //   this.$message.warning("请至少设置一个渠道类型权限");
      //   return;
      // }
      let arr = [];
      this.platTypeList.map((item) => {
        if (this.platTypePerms.includes(item.typeValue)) {
          arr.push({
            ...item,
            isPerm: true,
          });
        } else {
          arr.push({
            ...item,
            isPerm: false,
          });
        }
      });

      // arr.push({
      //   ...this.allChannelData,
      //   isPerm: this.channelPermCheckAll,
      // });

      // this.channelList.map((item) => {
      //   if (this.channelPerm.includes(item.typeValue)) {
      //     arr.push({
      //       ...item,
      //       isPerm: true,
      //     });
      //   } else {
      //     arr.push({
      //       ...item,
      //       isPerm: false,
      //     });
      //   }
      // });

      this.geoList.map((item) => {
        arr.push({
          ...item,
          isPerm: item.typeValue == this.geoPerm,
        });
      });
      // 工作室小组筛选处理
      this.groupList.map((item) => {
        arr.push({
          ...item,
        });
      });
      this.loading = true;
      const api = this.refType == 1 ? saveRoleRefPerms : saveUserRefPerms;
      api(arr).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.$message.success("编辑成功！");
          this.formVisible = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.perm-modal {
  .perm-modal-table {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #e5e6eb;
    box-sizing: border-box;
    .table-header {
      height: 20px;
      background: #f0f0f8;
      display: flex;
      color: #000000a6;
      font-weight: 600;
      font-size: 14px;
      padding: 6px 25px;
    }
    .table-content {
      padding: 12px 22px 24px 21px;
      max-height: 446px;
      display: flex;
      flex-direction: column;
      .tablet-border {
        width: 551px;
        height: 286px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        display: flex;
        margin-top: 12px;

        .left-border {
          width: 40%;
          height: 100%;
          overflow-y: auto;
          border-right: 1px solid rgba(0, 0, 0, 0.15);

          .leftItem {
            padding: 0px 15px 0px 15px;
            height: 40px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            display: flex;
            align-items: center;
            justify-content: space-between;
            .el-icon-arrow-right {
              font-weight: bold;
              cursor: pointer;
            }
          }
        }

        .right-border {
          width: 60%;
          height: 100%;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: rgba(0, 0, 0, 0.2);
          }

          .rightItem {
            padding: 0px 15px 0px 15px;
            height: 40px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }

          .rightItemLast {
            padding: 0px 15px 0px 15px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
        }
      }
    }
  }
}
</style>
